/**
 * Creator API abstraction for JavaScript
 */

import {
  CREATOR_BASE_URL,
  SHOPWARE_BASE_URL
} from '../../utils/configure-environment';
import axios from 'axios';
import colors from '@/api/collection/colors';
import fonts from '@/api/collection/fonts';
import products from '@/api/collection/products';
import productFilters from '@/api/collection/product-filters';

const encodeComposition = composition =>
  window.btoa(encodeURIComponent(JSON.stringify(composition)));

const config = {
  baseURL: `${SHOPWARE_BASE_URL}/creator-api`,
  baseCreatorURL: `${CREATOR_BASE_URL}/api/v0`,
  endpoints: {
    share: `${SHOPWARE_BASE_URL}/creator-api/share`,
    price: `${SHOPWARE_BASE_URL}/creator-api/price`,
    colors: `${CREATOR_BASE_URL}/api/v0/colors`,
    fonts: `${CREATOR_BASE_URL}/api/v0/fonts`,
    products: `${CREATOR_BASE_URL}/api/v0/products`,
    productFilters: `${CREATOR_BASE_URL}/api/v0/filters/product`
  }
};

const handleResponse = (response, errorMessage) => {
  if (response.status !== 200 || response.data.success === false) {
    throw errorMessage;
  }
  return response.data;
};

const CreatorApi = {
  config,

  share: {
    async create(articleNumber, composition) {
      const data = new FormData();
      data.append('sCompositionHash', encodeComposition(composition));
      data.append('articleNumber', articleNumber);

      const response = await axios.post(config.endpoints.share, data);
      const result = handleResponse(response, 'unable to create share link');

      if (result.link) {
        return result.link;
      }

      if (result.hash) {
        return `${window.location.origin}/s/${result.hash}`;
      }

      throw 'unable to create share link';
    },

    async get(uuid) {
      const response = await axios.get(`${config.endpoints.share}?id=${uuid}`);
      const result = handleResponse(response, 'unable to get share');

      if (!result.articleRef || !result.composition) {
        throw 'unable to get share';
      }

      return {
        articleNumber: result.articleRef,
        composition: result.composition
      };
    }
  },

  price: {
    async resolve(articleNumber, composition) {
      const formData = new FormData();
      formData.append('articleNumber', articleNumber);
      formData.append('sCompositionHash', encodeComposition(composition));

      const response = await axios.post(config.endpoints.price, formData);
      const result = handleResponse(response, 'Unable to determine price');

      return result.price;
    }
  },

  colors,
  fonts,
  products,
  productFilters
};

export const CREATOR_API = CreatorApi;
